import React from 'react';
import { handleSignIn } from '../../Scripts/SignIn';

export default function Home({ loggedInUser }) {

    let signIn;
    if (loggedInUser !== undefined) {
        let loginButton = !loggedInUser.isAuthenticated &&
            (<div><button className="button" onClick={() => handleSignIn("/b2r")}>Sign In</button></div>);

        signIn = (<div className="signIn">
            <div>
                <div className="font-bold">Sign into your account</div>
                <div>Sign in with your D.R. Horton account</div>
            </div>
            <br />
            {loginButton}
        </div>)
    }

    let content = (<div className="welcomeScreen">
        <div className="welcome">
            <h1>Welcome to Docshare</h1>
            <div className="font-bold">Access your documents in one of the following ways:</div>
            <br />
            <div className="instructions">1 - Use the link provided in your email along with the access code.</div>
            <div className="instructions">2 - Create an account using the provided link, and sign in with your new account.</div>
            <div className="instructions">3 - Select the right path from the menu.</div>
        </div>
        {signIn}
    </div>);

    return (content);
}
